import { Component, OnInit, OnDestroy } from "@angular/core";

import { DataService_AlertMaintenance } from "../shared/data.service";

import { wsAlertMaintenanceSpecialAlertEditParm } from "../shared/wsAlertMaintenanceSpecialAlertInfo";
import { wsAlertMaintenanceSpecialAlertEditInfo } from "../shared/wsAlertMaintenanceSpecialAlertInfo";
import { wsAlertMaintenanceSpecialAlertSoundInfo } from "../shared/wsAlertMaintenanceSpecialAlertInfo";
import { wsAlertMaintenanceSpecialAlertHomeroomInfo } from "../shared/wsAlertMaintenanceSpecialAlertInfo";
import { wsAlertMaintenanceSpecialAlertEditStationModeInfo } from "../shared/wsAlertMaintenanceSpecialAlertInfo";
import { wsAlertMaintenanceSpecialAlertUpdateParm } from "../shared/wsAlertMaintenanceSpecialAlertInfo";
import { wsAlertMaintenanceSpecialAlertUpdateStationModeInfo } from "../shared/wsAlertMaintenanceSpecialAlertInfo";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

@Component({
	selector: "app-root",
	templateUrl: "./editspecialalert.component.html",
	styleUrls: ["./editspecialalert.component.css"],
	providers: [ConfirmationService],
})
export class EditSpecialAlertComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_AlertMaintenance,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserID: number;
	public UserLevelID: number;
	public SchoolID: number = -1;
	public AlertID: number = -1;

	public SpecialAlertData: wsAlertMaintenanceSpecialAlertEditInfo;

	public lstSoundItems: wsAlertMaintenanceSpecialAlertSoundInfo[] = [];
	public SelectedSound: wsAlertMaintenanceSpecialAlertSoundInfo;

	public lstHomeroomItems: wsAlertMaintenanceSpecialAlertHomeroomInfo[] = [];
	public SelectedHomeroom: wsAlertMaintenanceSpecialAlertHomeroomInfo;

	public lstStationModeItems: wsAlertMaintenanceSpecialAlertEditStationModeInfo[] = [];
	public isSelectAll: boolean = false;

	public AlertCD: string = "";
	public rMessage: string = "";
	public rMessagecolor: string = "#ebebeb;"; // Default to match border color until loaded
	public rSpecialAlertHandling: string = "";

	public mp3Player: any = new Audio();

	//	DataTable page counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserID = this.dialogConfig.data.UserID;
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.AlertID = this.dialogConfig.data.AlertID;

		let parm: wsAlertMaintenanceSpecialAlertEditParm = {
			UserID: this.UserID,
			AlertID: this.AlertID,
			SchoolID: this.SchoolID,
		};

		this.isBusy = true;
		this.dataService.AlertMaintenanceSpecialAlertEditDataGet(parm).subscribe((data) => this.AlertMaintenanceSpecialAlertEditDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceSpecialAlertEditDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceSpecialAlertEditDataGet_Complete(data: any) {
		this.SpecialAlertData = data;

		this.lstSoundItems = this.SpecialAlertData.SoundItems;
		this.lstHomeroomItems = this.SpecialAlertData.HomeroomItems;
		this.lstStationModeItems = this.SpecialAlertData.StationModeItems;
		this.AlertCD = this.SpecialAlertData.AlertCD;
		this.rMessage = this.SpecialAlertData.Message;
		this.rMessagecolor = this.SpecialAlertData.FontColor;

		//
		//	Select Default Target
		//
		this.SelectedSound = this.lstSoundItems[0];

		this.lstSoundItems.forEach((item) => {
			if (item.SoundLibraryID == this.SpecialAlertData.SoundLibraryID) {
				this.SelectedSound = item;
			}
		});

		//
		//	Select Default Homeroom
		//
		this.SelectedHomeroom = this.lstHomeroomItems[0];

		this.lstHomeroomItems.forEach((item) => {
			if (item.HomeRoomID == Number(this.SpecialAlertData.SpecialAlertHandling)) {
				this.SelectedHomeroom = item;
			}
		});

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHomeroomChange
	//
	//-----------------------------------------------------------------------------------------------------
	onHomeroomChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSoundChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSoundChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSelectAll
	//
	//-----------------------------------------------------------------------------------------------------
	onSelectAll(e: any) {
		this.lstStationModeItems.forEach((item) => {
			if (this.isSelectAll == true) {
				item.Active = true;
			} else {
				item.Active = false;
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPlay
	//
	//-----------------------------------------------------------------------------------------------------
	onPlay() {
		if (this.SelectedSound.SoundFile != "(NONE)") {
			this.mp3Player.pause(); // First, Try to stop any playing files
			this.mp3Player = new Audio(this.SelectedSound.SoundData);
			this.mp3Player.play();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStop
	//
	//-----------------------------------------------------------------------------------------------------
	onStop() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdate() {
		this.ErrorMessage = "";

		//
		// Validate Message
		//
		if (this.rMessage.length < 1) {
			this.ErrorMessage = "Message must be entered.";
			return;
		}

		let lstStationModes: wsAlertMaintenanceSpecialAlertUpdateStationModeInfo[] = [];

		this.lstStationModeItems.forEach((item) => {
			lstStationModes.push({
				StationModeID: item.StationModeID,
				Active: item.Active,
			});
		});

		let parm: wsAlertMaintenanceSpecialAlertUpdateParm = {
			AlertID: this.AlertID,
			AlertCD: this.AlertCD,
			Message: this.rMessage,
			FontColor: this.rMessagecolor,
			SoundLibraryID: this.SelectedSound.SoundLibraryID,
			SpecialAlertHandling: String(this.SelectedHomeroom.HomeRoomID),
			StationModeItems: lstStationModes,
		};

		this.isBusy = true;
		this.dataService.AlertMaintenanceSpecialAlertUpdate(parm).subscribe((data) => this.AlertMaintenanceSpecialAlertUpdate_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceSpecialAlertUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceSpecialAlertUpdate_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
